// Local-only "clear" / archive list for terminal negotiation rows.
// Per-user, persisted in localStorage. No DB migration.

const key = (uid: string) => `lr.dismissedOfferIds.${uid}`;

export const getDismissed = (uid: string): Set<string> => {
  if (!uid) return new Set();
  try {
    const raw = localStorage.getItem(key(uid));
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
};

const persist = (uid: string, set: Set<string>) => {
  try {
    localStorage.setItem(key(uid), JSON.stringify([...set]));
  } catch {
    // ignore quota/availability errors
  }
};

export const dismissOffer = (uid: string, offerId: string): Set<string> => {
  const s = getDismissed(uid);
  s.add(offerId);
  persist(uid, s);
  return s;
};

export const restoreOffer = (uid: string, offerId: string): Set<string> => {
  const s = getDismissed(uid);
  s.delete(offerId);
  persist(uid, s);
  return s;
};
